var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInputClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.853575C0 1.28766 0.0614052 1.38075 0.36179 1.67928C1.17345 2.48604 8.04212 9.31802 8.16406 9.50005C8.05932 9.6564 6.2777 11.4049 6.09523 11.5874L0.380298 17.3022C0.0717482 17.6098 0 17.7042 0 18.1465C0 18.6067 0.402618 19 1.00197 19C1.43714 19 1.83606 18.4813 2.19872 18.1187L9.50005 10.8359C9.68775 10.9617 16.4808 17.7952 17.3022 18.6197C17.6098 18.9284 17.7042 19 18.1465 19C18.6067 19 19 18.5974 19 17.998C19 17.5629 18.4813 17.1639 18.1187 16.8013C17.4982 16.1807 10.9608 9.68656 10.8359 9.50005C10.9523 9.32618 14.8447 5.47268 14.983 5.33452L18.6197 1.69779C18.9284 1.39022 19 1.29582 19 0.853575C19 0.372786 18.5931 0 17.998 0C17.5597 0 17.1727 0.509968 16.8013 0.881338C16.4458 1.23681 16.1177 1.56496 15.7622 1.92044L10.0474 7.63525C9.89407 7.78855 9.66054 8.0566 9.50005 8.16406C9.31159 8.03798 2.52044 1.20578 1.69779 0.380407C1.38946 0.0709861 1.30693 0 0.853575 0C0.421562 0 0 0.421562 0 0.853575H0Z",
    fill: "#ACACAC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputClose);
export default __webpack_public_path__ + "static/media/input-close.190f405efe3493f8f5e76d2f9b0ca092.svg";
export { ForwardRef as ReactComponent };